import { useMemo } from "react";
import { SCHEDULE_STATE } from "../types";
import { useSchedulerStore } from "../state/scheduler.store";

export const useMeetingStatus = () => {
  const { ui } = useSchedulerStore();

  const scheduleState = useMemo(() => {
    switch (ui?.currentStep) {
      case "scheduling":
        return SCHEDULE_STATE.SCHEDULING;
      case "scheduled":
        return SCHEDULE_STATE.SCHEDULING_SUCCESS;
      case "scheduling_cancelled":
        return SCHEDULE_STATE.MEETING_CANCELLED;
      case "scheduling_failed":
        return SCHEDULE_STATE.SCHEDULING_FAIL;
      case "availability":
        return SCHEDULE_STATE.AVAILABILITY;
      default:
        return null;
    }
  }, [ui?.currentStep]);

  return scheduleState;
};
